import { render, staticRenderFns } from "./generateOrderList.vue?vue&type=template&id=2cba4afc&scoped=true"
import script from "./generateOrderList.vue?vue&type=script&lang=js"
export * from "./generateOrderList.vue?vue&type=script&lang=js"
import style0 from "./generateOrderList.vue?vue&type=style&index=0&id=2cba4afc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cba4afc",
  null
  
)

export default component.exports